import { render, staticRenderFns } from "./LoginPhone.vue?vue&type=template&id=50afd0bf&scoped=true&"
import script from "./LoginPhone.vue?vue&type=script&lang=js&"
export * from "./LoginPhone.vue?vue&type=script&lang=js&"
import style0 from "./LoginPhone.vue?vue&type=style&index=0&id=50afd0bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afd0bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50afd0bf')) {
      api.createRecord('50afd0bf', component.options)
    } else {
      api.reload('50afd0bf', component.options)
    }
    module.hot.accept("./LoginPhone.vue?vue&type=template&id=50afd0bf&scoped=true&", function () {
      api.rerender('50afd0bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/LoginPhone.vue"
export default component.exports